import React, { useEffect, useState } from 'react';

import { Card, Button } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import 'react-toastify/dist/ReactToastify.css';
import './ResourceBookingOverview.scss';
import Bookingcalendar from '../../Shared/Bookingcalendar/Bookingcalendar';

function ResourceBookingOverview() {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [resources, setResources] = useState<Array<any>>([]);
    const [resourceTypes, setResourceTypes] = useState<Array<any>>([]);

    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/resources",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/resourceTypes",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
        .then(axios.spread((...res) => {
            setResources(res[0].data);
            setResourceTypes(res[1].data);
        }))
        .catch(err => console.log(err));
    }
    function handleSaveBooking(resource){
        axios.put('/api/resources/updateBookings/' + resource._id, {
            bookings: resource.bookings.map(b => { 
                return {
                    ...b, 
                    bookingtimes: b.bookingtimes.map(t => { 
                        return { 
                            ...t, 
                            state: undefined 
                        } 
                    })
                } 
            })
        }, {
            headers: {'x-access-token': auth.user["token"]}
        }).then((res) => {
            fetchData();
        });
    }

    useEffect(() => {
        fetchData();
    }, []);
    
    useEffect(() => {
        const interval = setInterval(() => {
            fetchData();
        },60*1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div className="maincontent">
                <div className="resourceoverview-container">
                    <Card>
                        <Card.Body>
                            <h4 className="header-title">{t("resourceoverview.title")}</h4>
                            <br />
                            <Bookingcalendar
                                fetchDataPass={fetchData}
                                editorShowBookingInfo={true}
                                editorShowBookingLink={true}
                                //editAll={auth.user["userdata"]["orgRole"][0] == "cleaningstaff" ? false : true}
                                editAll={true}
                                showEventNames={true}
                                bookingId="overview"
                                resources={
                                    resources.map(resource => {
                                        let resourceType = resourceTypes.find(i => i._id == resource.resourceType);
                                        return {...resource, resourceTypeName: (resourceType != undefined ? resourceType.name : "") };
                                    })
                                }
                                onChange={(resources, resource) => {
                                    handleSaveBooking(resource);
                                }}
                                confirmBtnText={t("bookingcalendar.modal.editevent.save")}
                            ></Bookingcalendar>
                            <hr/>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </>
    )
}
export default ResourceBookingOverview;